import { render, staticRenderFns } from "./LateralMenu.vue?vue&type=template&id=fd655aec&scoped=true&"
import script from "./LateralMenu.vue?vue&type=script&lang=js&"
export * from "./LateralMenu.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=fd655aec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd655aec",
  null
  
)

export default component.exports